import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTableauComponent } from './simple-icons-tableau.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTableauComponent ],
    exports:      [ SimpleIconsTableauComponent ],
    bootstrap:    []
})
export class SimpleIconsTableauModule {}
